import { module } from 'modujs';
import Emitter from "tiny-emitter/instance";

export default class extends module {

    constructor( m ) {
        super( m );
        this.isActive = false;
        this.target = this.el.dataset.target;
        this.onEscapeKeyBind = this.onEscapeKey.bind( this );
        window.addEventListener( 'keydown', this.onEscapeKeyBind );
        if( this.el.dataset.event ){
            this.eventParts = this.el.dataset.event.split( ',' );
            this.eventToggleParts = this.el.dataset.eventToggle.split( ',' );

        }

        this.el.addEventListener( 'click', e => {
            this.isActive = ! this.isActive;
            if( this.isActive && this.eventParts ){
                Emitter.on( this.eventParts[0], this.onClick.bind( this ) );
                this.call( this.eventParts[0], this.eventParts[1] );
            } else if( ! this.isActive ) {
                this.onClick();
                setTimeout( ()=> {
                    this.call( this.eventToggleParts[0], this.eventToggleParts[1] );
                }, 1000 );
            }
        } );

    }

    onClick( e ){
        if( this.eventParts ){
            Emitter.off( this.eventParts[0] );
        }
        this.toggleTargets();
        this.el.classList.toggle( 'is-active' );
        this.call( 'update', false, 'Scroll' );

    }

    toggleTargets() {
        [ ...document.querySelectorAll(this.target  ) ].forEach( ( target ) => {
            [ ...target.dataset.toggleStateClass.split( ' ' ) ].map( className => {
                target.classList.toggle( className );
            } );
        } );
    }

    forceHide( target ) {
        return;
        if ( this.target !== target && this.isActive ) this.hide();
    }

    hide() { if ( this.isActive ) this.el.click() }

    onEscapeKey( e ) { if ( e.key === "Escape" ) this.hide() }

    destroy() { window.removeEventListener( 'keydown', this.onEscapeKeyBind ) }

}
